import { useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

import Title from './Title';
import Action, { ActionProps } from './Action';

interface NotificationSwitchesProps {
  formik: FormikProps<any>;
  type: 'standby' | 'booking' | 'event' | 'feedback' | 'request';
  notifications: ActionProps['notifications'];
}

export function NotificationSwitches(props: Readonly<NotificationSwitchesProps>) {
  const { type, ...rest } = props;
  const theme = useTheme();
  const { t } = useTranslation('notification');

  const { booking, event, request, feedback } = rest.formik.values;

  return (
    <Stack width="100%">
      {type === 'standby' && (
        <>
          <Title title={t(`${type}.title`)} />
          <Action type="standby" subtype="all" {...rest} />
        </>
      )}
      {type === 'booking' && Object.keys(rest.formik.values.booking).length > 0 && (
        <>
          <Title icon={<theme.icons.booking />} title={t(`${type}.title`)} />
          {booking.new && <Action type="booking" subtype="new" {...rest} />}
          {booking.update && <Action type="booking" subtype="update" {...rest} />}
          {booking.message && <Action type="booking" subtype="message" {...rest} />}
          {booking.late && <Action type="booking" subtype="late" {...rest} />}
        </>
      )}
      {type === 'event' && Object.keys(rest.formik.values.event).length > 0 && (
        <>
          <Title icon={<theme.icons.event />} title={t(`${type}.title`)} />
          {event.invitation && <Action type="event" subtype="invitation" {...rest} />}
          {event.update && <Action type="event" subtype="update" {...rest} />}
          {event.upcoming && <Action type="event" subtype="upcoming" {...rest} />}
        </>
      )}
      {type === 'request' && Object.keys(rest.formik.values.request).length > 0 && (
        <>
          <Title icon={<theme.icons.request />} title={t(`${type}.title`)} />
          {request.message && <Action type="request" subtype="message" {...rest} />}
          {request.friendship && <Action type="request" subtype="friendship" {...rest} />}
          {request.mention && <Action type="request" subtype="mention" {...rest} />}
        </>
      )}
      {type === 'feedback' && Object.keys(rest.formik.values.feedback).length > 0 && (
        <>
          <Title icon={<theme.icons.feedback />} title={t(`${type}.title`)} />
          {feedback.new && <Action type="feedback" subtype="new" {...rest} />}
        </>
      )}
    </Stack>
  );
}
